<template lang="pug">
  span
    template(v-if="currency == 'USD'")
      i.flag-icon.flag-icon-us.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'THB'")
      i.flag-icon.flag-icon-th.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'IDR'")
      i.flag-icon.flag-icon-id.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'VND'")
      i.flag-icon.flag-icon-vn.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'CNY'")
      i.flag-icon.flag-icon-cn.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'HKD'")
      i.flag-icon.flag-icon-hk.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'KRW'")
      i.flag-icon.flag-icon-kr.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'AUD'")
      i.flag-icon.flag-icon-au.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'INR'")
      i.flag-icon.flag-icon-in.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'MMK'")
      //- i.flag-icon.flag-goo.mr-1
      i.flag-icon.flag-icon-mm.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'BDT'")
      i.flag-icon.flag-icon-bd.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'EUR'")
      i.flag-icon.flag-icon-eu.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'TND'")
      i.flag-icon.flag-icon-tn.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'ARS'")
      i.flag-icon.flag-icon-ar.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'BND'")
      i.flag-icon.flag-icon-bn.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'GOO'")
      i.flag-icon.flag-goo.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'PKR'")
      i.flag-icon.flag-icon-pk.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'UST'")
      i.flag-icon.flag-usdt.mr-1
      span #[b USDT ]
    template(v-else-if="currency == 'LAK'")
      i.flag-icon.flag-icon-la.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'JPY'")
      i.flag-icon.flag-icon-jp.mr-1
      span #[b {{ currency }} ]
    template(v-else)
      //- i.flag-icon.flag-icon-my.align-middle.mr-1
      i.flag-icon.flag-icon-mm.mr-1
      span #[b {{ currency }} ]
</template>

<script>
export default {
  props: {
    currency: ""
  }
}
</script>

<style lang="scss" scoped>
.flag-goo {
  background-image: url("/assets/img/goo.png");
  width: 18px;
  height: 14px;
}

.flag-usdt {
  background-image: url("/assets/img/usdt.png");
  width: 18px;
  height: 14px;
}
</style>
